import { instanceBo } from "../utils/axios.create";

export interface EmailProgramSummary {
	key: string;
	name: string;
	description: string;
	subject: string;
}

const listEmailPrograms = async (): Promise<EmailProgramSummary[]> =>
	instanceBo
		.get("/email-programs")
		.then((res) => res.data.body as EmailProgramSummary[])
		.catch((err) => Promise.reject(err.response?.data ?? err));

/**
 * The rendered document, as the chosen account would receive it.
 *
 * `brandingAccountId` is separate from the account already baked into
 * `instanceBo`'s baseURL: that one is the caller's tenant and every backoffice
 * call carries it, while this one is the account being looked AT. Omitted, the
 * backend falls back to the caller's own account.
 *
 * Returned as a string rather than as `text/html` on purpose: the caller
 * decides how to display it, and the page puts it in a sandboxed iframe.
 */
const previewEmailProgram = async (
	key: string,
	brandingAccountId?: string,
): Promise<string> =>
	instanceBo
		.get(`/email-programs/${key}/preview`, {
			params: brandingAccountId ? { brandingAccountId } : undefined,
		})
		.then((res) => (res.data.body as { html: string }).html)
		.catch((err) => Promise.reject(err.response?.data ?? err));

const sendTestEmail = async (
	key: string,
	email: string,
	brandingAccountId?: string,
): Promise<void> =>
	instanceBo
		.post(`/email-programs/${key}/test-send`, {
			email,
			// Left out entirely when absent, so the request looks the same as it
			// did before this option existed and the backend takes its default.
			...(brandingAccountId ? { brandingAccountId } : {}),
		})
		.then(() => undefined)
		.catch((err) => Promise.reject(err.response?.data ?? err));

export const emailProgramService = {
	listEmailPrograms,
	previewEmailProgram,
	sendTestEmail,
};
